// @flow
import React from "react";
import { useSelector } from "react-redux";
import {
  SelecaoCasasDecimais,
  SelecaoPeriodo,
  SelecaoPeriodicidade,
  SelecaoAjusteDias,
} from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";
import CheckboxUltimaNegociacaoMes from "../configuracoes/periodos/CheckboxUltimaNegociacaoMes/CheckboxUltimaNegociacaoMes";

export const processarPontualDiarioComFlagUltimaNegociacao = comGeradorDePeriodo(
  (state, medidas) => {
    const edicaoMedida = getEdicaoMedida(state);
    const dataBase = getDataBaseSelecionadaAsString(state);
    const modoSeries = isModoSeries(state);

    if (modoSeries) {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        ultimaNegociacao: edicaoMedida.ultimaNegociacaoMes,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    } else {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        periodicidade: edicaoMedida.periodicidade,
        ajusteDias: edicaoMedida.ajusteDias,
        dataBase: dataBase,
        ultimaNegociacao: edicaoMedida.ultimaNegociacaoMes,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    }
  }
);

const PontualDiarioComFlagUltimaNegociacao = () => {
  const modoSeries = useSelector(isModoSeries);

  return (
    <>
      <SelecaoPeriodo exibirPeriodicidade={false} />
      <div className="ConfiguracaoMedida__group">
        <div className="ConfiguracaoMedida__box">
          <SelecaoPeriodicidade />
        </div>

        <div className="ConfiguracaoMedida__box">
          <SelecaoAjusteDias />
        </div>
      </div>

      <div className="ConfiguracaoMedida">
        <div className="ConfiguracaoMedida__box">
          {!modoSeries && (
            <SelecaoCasasDecimais className="ConfiguracaoMedida__fixed" />
          )}
        </div>
        <div className="ConfiguracaoMedida__box">
          <CheckboxUltimaNegociacaoMes />
        </div>
      </div>
    </>
  );
};

export default PontualDiarioComFlagUltimaNegociacao;
